import { Drawer, Button, List, Space } from "antd";
import { setL1Visible } from "Components/Report/reportSlice";
import { useAppDispatch, useAppSelector } from "store/hook";
import DeviceChartsDrawer from "./Device_Charts_Drawer";
import { setOnViewDevice, setOnViewDevice_Period } from "Components/Report/reportSlice";
import { Typography } from "antd";
import { DateToFormattedString } from "../Periodic/Reports";

const { Text } = Typography;

const MultiDrawer = () => {
  const disp = useAppDispatch();
  const { L1Visible } = useAppSelector((state) => state.report);
  const closeL1Drawer = () => disp(setL1Visible(false));

  return (
    <Drawer title={<div>Device List</div>} onClose={closeL1Drawer} visible={L1Visible} destroyOnClose width={380}>
      <L1DeviceList />
      <DeviceChartsDrawer />
    </Drawer>
  );
};

export default MultiDrawer;

const L1DeviceList = () => {
  const { onEventValues, filterForm } = useAppSelector((state) => state.report);

  const disp = useAppDispatch();

  const getPeriod = (period: string) => {
    const end_utc = Math.round(Date.now() / 1000);
    switch (period) {
      case "day": //last day, unit hour
        return { end_utc, start_utc: end_utc - 86400, unit: 3600 };
      case "week": //last week, unit day
        return { end_utc, start_utc: end_utc - 604800, unit: 86400 };
      case "month": //last month, unit day
        return { end_utc, start_utc: end_utc - 2592000, unit: 86400 };
    }
  };
  // console.log(onEventValues);

  return (
    <List
      header={
        <Space direction="vertical" align="start">
          <Text>{`${onEventValues?.type.toUpperCase()} - ${onEventValues?.click.toUpperCase()}`}</Text>

          <Text>
            {`${DateToFormattedString(onEventValues?.start_utc * 1000)} - ${DateToFormattedString(
              onEventValues?.end_utc * 1000
            )}`}
          </Text>
        </Space>
      }
      size="small"
      itemLayout="horizontal"
      dataSource={onEventValues?.[onEventValues?.type]?.[onEventValues?.click]}
      renderItem={(item: string) => (
        <List.Item>
          <Space>
            <Text>{item}</Text>

            <Button
              size="small"
              type="link"
              onClick={() => {
                disp(setOnViewDevice(item));
                disp(setOnViewDevice_Period(getPeriod("month")));
              }}
            >
              Month
            </Button>

            <Button
              size="small"
              type="link"
              onClick={() => {
                disp(setOnViewDevice(item));
                // disp(setOnViewDevice_Period({ start_utc, end_utc, unit: 3600 }));
                disp(setOnViewDevice_Period(getPeriod("week")));
              }}
            >
              Week
            </Button>

            <Button
              size="small"
              type="link"
              onClick={() => {
                disp(setOnViewDevice(item));
                // disp(setOnViewDevice_Period({ start_utc, end_utc, unit: 3600 }));
                disp(setOnViewDevice_Period(getPeriod("day")));
              }}
            >
              Day
            </Button>
          </Space>
        </List.Item>
      )}
    />
  );
};
